import Vue from 'vue';
import Vuex from 'vuex';
import { encode, decode } from 'js-base64';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: '',
    headImg: '',
    phone: '',
    token: '',
    inviteCode: '',
    password: '',
    bannerImages: [
      'https://ustatic.hudongmiao.com/miao/common/bar-banner_176767896742378d1ab.webp'
    ],
    demoActivityURL: 'https://screen.009bar.com/#/?liveId=4472cd9c9e17457ebdf9b49113a58d55',
  },
  mutations: {
    updateUserInfo(state, data) {
      state.userName = data.userName || state.userName;
      state.headImg = data.headImg || state.headImg;
      state.phone = data.phone || state.phone;
      state.token = data.token || state.token;
      state.password = encode(data.password) || state.password;// 加密后的密码
      localStorage.setItem('token', state.token);
      localStorage.setItem('headImg', state.headImg);
      localStorage.setItem('userName', state.userName);
      localStorage.setItem('phone', state.phone);
      localStorage.setItem('password', state.password);
    },
    initUserInfo(state) {
      // 兼容之前官网字段
      const beforeUserName = localStorage.getItem('username');
      const beforeHeadImg = localStorage.getItem('headimg_url');
      let storageUserName = localStorage.getItem('userName');
      let storageHeadImg = localStorage.getItem('headImg');

      if (beforeUserName) {
        storageUserName = beforeUserName;
        localStorage.removeItem('username');
        localStorage.setItem('userName', storageUserName);
      }
      if (beforeHeadImg) {
        storageHeadImg = beforeHeadImg;
        localStorage.removeItem('headimg_url');
        localStorage.setItem('headImg', storageHeadImg);
      }
      localStorage.removeItem('h5_openId');
      const storagePhone = localStorage.getItem('phone');
      const storagePassword = localStorage.getItem('password') ? decode(localStorage.getItem('password')) : '';
      const storageToken = localStorage.getItem('token');
      state.userName = storageUserName || state.userName;
      state.headImg = storageHeadImg || state.headImg;
      state.phone = storagePhone || state.phone;
      state.token = storageToken || state.token;
      state.password = storagePassword || state.storagePassword;
    },
    resetUserInfo(state) {
      localStorage.clear();
      state.userName = '';
      state.headImg = '';
      state.phone = '';
      state.password = '';
      state.token = '';
    },
    setInviteCode(state, data) {
      state.inviteCode = data;
    },
    setBannerImages(state, data) {
      state.bannerImages = data || [];
    },
  },
});
